// import React, { useState, useEffect, useCallback } from "react";

// import { useNavigate, useParams } from "react-router-dom";

// import { toast } from "react-toastify";

// import { Filter, Search } from "lucide-react";

// import { FaArrowLeft } from "react-icons/fa";

// import Pagination from "../helpers/Pagination";
// import PageLoader from "../helpers/PageLoader";

// import api from "../common/apiClient";
// import SummaryApi from "../common/SummaryApi";
// import { formatDateTime } from "../helpers/formatDateTime";
// import SelectDropdown from "../customStyles/SelectDropdown";
// import CustomDatePicker from "../customStyles/CustomDatePicker";

// const clientStatusOptions = [
//   {
//     label: "ACTIVE",
//     value: "ACTIVE",
//   },
//   {
//     label: "INACTIVE",
//     value: "INACTIVE",
//   },
//   {
//     label: "ONETIME",
//     value: "ONETIME",
//   },
// ];


// const clientTypeOptions = [
//   {
//     label: "RECURRING",
//     value: "RECURRING",
//   },
//   {
//     label: "NON RECURRING",
//     value: "NON_RECURRING",
//   },
// ];



// const OnboardingClients = () => {
//   const { portalName } = useParams();

//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(true);

//   const [clients, setClients] = useState([]);

//   const [users, setUsers] = useState([]);

//   const [selectedUser, setSelectedUser] = useState("");

//   const [selectedFilterHandleBy, setSelectedFilterHandleBy] = useState("");

//   const [selectedClientStatus, setSelectedClientStatus] = useState("");
  
//   const [selectedClientType, setSelectedClientType] = useState("");

//   const [fromDate, setFromDate] = useState("");

//   const [toDate, setToDate] = useState("");

//   const [appliedFilters, setAppliedFilters] = useState({
//     userId: "",
//     handleBy: "",
//     fromDate: "",
//     toDate: "",
//     clientStatus: "",
//     clientType: "",
//   });

//   const [showFilters, setShowFilters] = useState(true);

//   const [templates, setTemplates] = useState([]);

//   const [selectedHandleBy, setSelectedHandleBy] = useState("");

//   const [clientOnboardingDate, setClientOnboardingDate] = useState("");

//   const [selectedTemplate, setSelectedTemplate] = useState("");

//   const [startingOnboarding, setStartingOnboarding] = useState(false);
  
//   const [searchTerm, setSearchTerm] = useState("");

//   const [itemsPerPage, setItemsPerPage] = useState(10);

//   const [currentPage, setCurrentPage] = useState(1);

//   const [pagination, setPagination] = useState({
//     total: 0,
//     page: 1,
//     limit: 10,
//     totalPages: 0,
//   });

//   const filteredClients = clients.filter((client) => {
//     const search = searchTerm.toLowerCase();

//     return (
//       client.clientName?.toLowerCase().includes(search) ||
//       client.contactName?.toLowerCase().includes(search) ||
//       client.clientId?.toLowerCase().includes(search) ||
//       client.contactPhone?.toLowerCase().includes(search)
//     );
//   });  

//   const [startModal, setStartModal] = useState({
//     open: false,
//     client: null,
//   });

  

//   const fetchClients = useCallback(async () => {
//     try {
//       setLoading(true);

//       const response = await api({
//         ...SummaryApi.getAllWonClients,

//         params: {
//           page: currentPage,
//           limit: itemsPerPage,

//           ...(appliedFilters.userId && {
//             userId: appliedFilters.userId,
//           }),

//           ...(appliedFilters.handleBy && {
//             handleBy: appliedFilters.handleBy,
//           }),

//           ...(appliedFilters.fromDate && {
//             fromDate: appliedFilters.fromDate,
//           }),

//           ...(appliedFilters.toDate && {
//             toDate: appliedFilters.toDate,
//           }),

//           ...(appliedFilters.clientStatus && {
//             clientStatus: appliedFilters.clientStatus,
//           }),

//           ...(appliedFilters.clientType && {
//             clientType: appliedFilters.clientType,
//           }),
//         },
//       });

//       if (response.data.success) {
//         setClients(response.data.data || []);

//         setPagination(response.data.pagination);
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Failed to fetch clients");
//     } finally {
//       setLoading(false);
//     }
//   }, [currentPage, itemsPerPage, appliedFilters]);

//   useEffect(() => {
//     fetchClients();
//   }, [fetchClients]);

//   const fetchUsers = useCallback(async () => {
//     try {
//       const response = await api.get(SummaryApi.getAllUsers.url);

//       if (response.data.success) {
//         const activeUsers = (response.data.data || []).filter(
//           (u) => u.isActive !== false,
//         );

//         const formatted = activeUsers.map((u) => ({
//           label: `${u.firstName} ${u.lastName} (${u.customRoleId?.roleName || u.role})`,
//           value: u._id,
//         }));

//         setUsers(formatted);
//       }
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//   }, []);

//   useEffect(() => {
//     fetchUsers();
//   }, [fetchUsers]);

//   const fetchTemplates = async () => {
//     try {
//       const response = await api({
//         ...SummaryApi.getAllOnboardingTemplates,
//       });

//     if (response.data.success) {
//       const templateData = response.data.data || [];

//       const formattedTemplates = templateData.map((t) => ({
//         label: t.templateName,
//         value: t._id,
//       }));

//       setTemplates(formattedTemplates);

//       if (formattedTemplates.length === 1) {
//         setSelectedTemplate(formattedTemplates[0].value);
//       }
//     }
//     } catch (error) {
//       toast.error("Failed to fetch templates");
//     }
//   };

//   const handleStartOnboarding = async () => {
//     if (startingOnboarding) return;
//     try {

//     setStartingOnboarding(true);

//     const productCategory =
//       startModal.client?.productCategory?.length > 0;

//     const requirement =
//       startModal.client?.requirement?.length > 0;

//     if (!productCategory) {
//       return toast.error("Product Category is required");
//     }

//     if (!requirement) {
//       return toast.error("Requirement is required");
//     }

//     if (!selectedTemplate) {
//       return toast.error("Please select onboarding template");
//     }
//     if (!selectedHandleBy) {
//       return toast.error("Please select handle by");
//     }
//     if (!clientOnboardingDate) {
//       return toast.error("Please select onboarding date");
//     }
//       await api({
//         ...SummaryApi.startClientOnboarding,

//         data: {
//           clientId: startModal.client._id,
//           templateId: selectedTemplate,
//           handleBy: selectedHandleBy,
//           clientOnboardingDate,
//           productCategory:
//             startModal.client.productCategory?.map(
//               (item) =>
//                 item
//                   ?.toLowerCase()
//                   ?.replace(/\s+/g, "_"),
//             ) || [],
//           requirement: startModal.client.requirement,
//         },
//       });

//       toast.success("Onboarding started successfully");

//       setStartModal({
//         open: false,
//         client: null,
//       });
//       setClientOnboardingDate("");
//       setSelectedTemplate("");
//       setSelectedHandleBy("");

//       fetchClients();
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message || "Failed to start onboarding",
//       );
//     }finally {
//     setStartingOnboarding(false);
//   }
//   };

//   const handleApplyFilters = () => {
//     const newFilters = {
//       userId: selectedUser,
//       handleBy: selectedFilterHandleBy,
//       clientStatus: selectedClientStatus,
//       clientType: selectedClientType,
//       fromDate,
//       toDate,
//     };

//     const isSame =
//       appliedFilters.userId === newFilters.userId &&
//       appliedFilters.handleBy === newFilters.handleBy &&
//       appliedFilters.fromDate === newFilters.fromDate &&
//       appliedFilters.toDate === newFilters.toDate &&
//       appliedFilters.clientStatus === newFilters.clientStatus &&
//       appliedFilters.clientType === newFilters.clientType;

//     if (isSame) {
//       return; // API call avoid
//     }

//     setAppliedFilters(newFilters);

//     setCurrentPage(1);
//   };

//   const handleClearFilters = () => {
//     const hasFilters = selectedUser || selectedFilterHandleBy || fromDate || toDate || selectedClientStatus ||selectedClientStatus ;

//     if (!hasFilters) {
//       return;
//     }

//     setSelectedUser("");
//     setFromDate("");
//     setToDate("");
//     setSelectedFilterHandleBy("");
//     setSelectedClientStatus("");
//     setSelectedClientType("");
//     setAppliedFilters({
//       userId: "",
//       fromDate: "",
//       handleBy: "",
//       toDate: "",
//       clientStatus: "",
//       clientType: "",
//     });

//     setCurrentPage(1);
//   };

//   const hasChanges =
//     selectedUser !== appliedFilters.userId ||
//     selectedFilterHandleBy !== appliedFilters.handleBy ||
//     fromDate !== appliedFilters.fromDate ||
//     toDate !== appliedFilters.toDate || 
//     selectedClientStatus !== appliedFilters.clientStatus ||
//     selectedClientType !== appliedFilters.clientType;

//   return (
//     <>
//     <div className="w-full p-4">
//       {/* Header */}
//       <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
//         <div className="flex items-center">
//           <button
//             onClick={() => navigate(-1)}
//             className="mr-2 hover:bg-gray-300 rounded-full p-1"
//           >
//             <FaArrowLeft />
//           </button>

//           <h1 className="text-2xl font-bold">Onboarded Clients</h1>
//         </div>

//         <div className="flex items-center gap-2">
//           {/* Search */}

//           <div className="relative w-full md:w-80">
//             <input
//               type="text"
//               placeholder="Search client..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="w-full pl-10 pr-4 py-2 border rounded-lg"
//             />

//             <Search className="absolute left-3 top-3" size={18} />
//           </div>

//           {/* Filter Toggle */}

//           <button
//             onClick={() => setShowFilters(!showFilters)}
//             className={`p-2 rounded-lg transition ${
//               showFilters
//                 ? "bg-red-100 text-red-600"
//                 : "bg-gray-100 text-gray-600"
//             }`}
//           >
//             <Filter size={24} />
//           </button>
//         </div>
//       </div>
//       {showFilters && (
//         <div className="bg-white rounded-md p-4 mb-4 shadow-sm">
//           <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-8 gap-3">
//             {/* User */}

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 User
//               </label>

//               <SelectDropdown
//                 options={users}
//                 value={selectedUser}
//                 onChange={(value) => setSelectedUser(value)}
//                 placeholder="All Users"
//                 valueKey="value"
//                 labelKey="label"
//                 searchable={true}
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Handle By
//               </label>

//               <SelectDropdown
//                 options={users}
//                 value={selectedFilterHandleBy}
//                 onChange={(value) => setSelectedFilterHandleBy(value)}
//                 placeholder="All Handlers"
//                 valueKey="value"
//                 labelKey="label"
//                 searchable={true}
//               />
//             </div>
//             {/* From Date */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Client Status
//               </label>

//               <SelectDropdown
//                 options={clientStatusOptions}
//                 value={selectedClientStatus}
//                 onChange={(value) =>
//                   setSelectedClientStatus(value)
//                 }
//                 placeholder="All Status"
//                 valueKey="value"
//                 labelKey="label"
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Client Type
//               </label>

//               <SelectDropdown
//                 options={clientTypeOptions}
//                 value={selectedClientType}
//                 onChange={(value) =>
//                   setSelectedClientType(value)
//                 }
//                 placeholder="All Types"
//                 valueKey="value"
//                 labelKey="label"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 From Date
//               </label>

//               <CustomDatePicker
//                 value={fromDate}
//                 onChange={(date) => {
//                   setFromDate(date);

//                   if (!toDate && date) {
//                     setToDate(date);
//                   }
//                 }}
//                 placeholder="Select Date"
//                 showCapacityInfo={false}
//               />
//             </div>

//             {/* To Date */}

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 To Date
//               </label>

//               <CustomDatePicker
//                 value={toDate}
//                 onChange={(date) => {
//                   setToDate(date);

//                   if (!fromDate && date) {
//                     setFromDate(date);
//                   }
//                 }}
//                 placeholder="Select Date"
//                 showCapacityInfo={false}
//               />
//             </div>

//             {/* Buttons */}

//             <div className="flex items-end gap-2 col-span-2">
//               <button
//                 disabled={!hasChanges}
//                 onClick={handleApplyFilters}
//                 className={`w-full md:w-auto px-4 py-2 rounded-lg text-white ${
//                   hasChanges
//                     ? "bg-red-500 hover:bg-red-600"
//                     : "bg-gray-300 cursor-not-allowed"
//                 }`}
//               >
//                 Apply
//               </button>

//               <button
//                 onClick={handleClearFilters}
//                 className="w-full md:w-auto bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg"
//               >
//                 Clear
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {/* Table */}
//       {loading ? (
//         <PageLoader />
//       ) : (
//         <div className="overflow-x-auto custom-scrollbar rounded-md">
//           <table className="min-w-full bg-white border-separate border-spacing-y-2 px-2">
//             <thead className="text-sm text-gray-600">
//               <tr className="text-center rounded-lg shadow-sm bg-red-100">
//                 <th className="py-4 px-4 rounded-l-lg">S.No</th>
//                 <th className="py-4 px-4 whitespace-nowrap">Client</th>
//                 <th className="py-4 px-4 whitespace-nowrap">Client Contact</th>
//                 <th className="py-4 px-4 whitespace-nowrap">Handled By</th>
//                 <th className="py-4 px-4 whitespace-nowrap">Sales By</th>
//                 <th className="py-4 px-4 whitespace-nowrap">Product Category</th>
//                 <th className="py-4 px-4 whitespace-nowrap">Overall Value(IV)</th>
//                 <th className="py-4 px-4 whitespace-nowrap">Recurring Value</th>
//                 <th className="py-4 px-4 whitespace-nowrap">Won Date</th>
//                 <th className="py-4 px-4 whitespace-nowrap">Phase Status</th>
//                 <th className="py-4 px-4 whitespace-nowrap">Client Status</th>
//                 <th className="py-4 px-4 whitespace-nowrap">Client Type(PS)</th>
//                 <th className="py-4 px-4 rounded-r-lg">Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {filteredClients.map((client, index) => (
//                 <tr
//                   key={client._id}
//                   className="bg-gray-50 hover:bg-gray-100 text-sm rounded-lg shadow-sm text-center"
//                 >
//                   <td className="py-3 px-4 font-medium text-gray-700 rounded-l-lg">
//                     {(currentPage - 1) * itemsPerPage + index + 1}
//                   </td>
//                   <td className="py-3 px-4">
//                     <div className="min-w-[120px]">
//                       <div className="font-medium text-gray-800 truncate">
//                         {client.clientId}
//                       </div>
//                       <div className="text-xs text-gray-500 truncate">
//                         {client.clientName}
//                       </div>
//                     </div>
//                   </td>
//                   <td className="py-3 px-4">
//                     <div className="min-w-[120px]">
//                       <div className="font-medium text-gray-800 truncate">
//                         {client.contactName}
//                       </div>
//                       <div className="text-xs text-gray-500 truncate">
//                         {client.contactPhone}
//                       </div>
//                     </div>
//                   </td>
//                   <td className="py-3 px-4">
//                     <div className="min-w-[120px]">
//                       <div className="font-medium text-gray-800 truncate">
//                         {client.handleBy?.firstName} {client.handleBy?.lastName}
//                       </div>
//                       <div className="text-xs text-gray-500 truncate">
//                         {client.handleBy?.userId || "N/A"}
//                       </div>
//                     </div>
//                   </td>
//                   <td className="py-3 px-4">
//                     <div className="min-w-[120px]">
//                       <div className="font-medium text-gray-800 truncate">
//                         {client.userId?.firstName} {client.userId?.lastName}
//                       </div>
//                       <div className="text-xs text-gray-500 truncate">
//                         {client.userId?.userId || "N/A"}
//                       </div>
//                     </div>
//                   </td>
//                   <td className="py-3 px-4 whitespace-nowrap">
//                     <span className="px-2 py-1.5 bg-red-100 rounded-lg">
//                       {client?.productCategory?.join(", ") || "Not Available"}
//                     </span>
//                     </td>
//                   <td className="py-3 px-4 whitespace-nowrap">
//                     {client.estimatedValue}
//                   </td>
//                   <td className="py-3 px-4 whitespace-nowrap">
//                     {client.clientType === "RECURRING"
//                       ? `₹ ${client.recurringValue || 0}`
//                       : "N/A"}
//                   </td>
//                   <td className="py-3 px-4 whitespace-nowrap">
//                     {formatDateTime(client.stageChangedAt, false)}
//                   </td>

//                   <td className="py-3 px-4 whitespace-nowrap">
//                     {client.onboardingStatus === "COMPLETED" ? (
//                       <span className="px-2 py-1 rounded-full bg-green-100 text-green-700 text-xs">
//                         COMPLETED
//                       </span>
//                     ) : client.onboardingStatus === "IN_PROGRESS" ? (
//                       <span className="px-2 py-1 rounded-full bg-yellow-100 text-yellow-700 text-xs">
//                         IN PROGRESS
//                       </span>
//                     ) : client.onboardingStatus === "NOT_STARTED" ? (
//                       <span className="px-2 py-1 rounded-full bg-red-100 text-red-700 text-xs">
//                         PENDING
//                       </span>
//                     ) : (
//                       <span className="px-2 py-1 rounded-full bg-red-100 text-red-700 text-xs">
//                         PENDING
//                       </span>
//                     )}
//                   </td>
//                 <td className="py-3 px-4 whitespace-nowrap">
//                   {client.clientStatus === "ACTIVE" ? (
//                     <span className="px-2 py-1 rounded-full bg-green-100 text-green-700 text-xs font-medium">
//                       ACTIVE
//                     </span>
//                   ) : client.clientStatus === "INACTIVE" ? (
//                     <span className="px-2 py-1 rounded-full bg-red-100 text-red-700 text-xs font-medium">
//                       INACTIVE
//                     </span>
//                   ) : client.clientStatus === "ONETIME" ? (
//                     <span className="px-2 py-1 rounded-full bg-blue-100 text-blue-700 text-xs font-medium">
//                       ONETIME
//                     </span>
//                   ) : (
//                     <span className="px-2 py-1 rounded-full bg-gray-100 text-gray-600 text-xs font-medium">
//                       NOT SET
//                     </span>
//                   )}
//                 </td>
//                 <td className="py-3 px-4 whitespace-nowrap">
//                   {client.clientType === "RECURRING" ? (
//                     <span className="px-2 py-1 rounded-full bg-purple-100 text-purple-700 text-xs font-medium">
//                       RECURRING
//                     </span>
//                   ) : client.clientType === "NON_RECURRING" ? (
//                     <span className="px-2 py-1 rounded-full bg-orange-100 text-orange-700 text-xs font-medium">
//                       NON RECURRING
//                     </span>
//                   ) : (
//                     <span className="px-2 py-1 rounded-full bg-gray-100 text-gray-600 text-xs font-medium">
//                       NOT SET
//                     </span>
//                   )}
//                 </td>
//                 <td className="py-3 px-4 text-gray-500 rounded-r-lg">
//                   {client.onboardingStarted ? (
//                     <div className="flex justify-center gap-2">
//                       <button
//                         className="bg-blue-500 text-white px-3 py-1 rounded"
//                         onClick={() =>
//                           navigate(
//                             `/${portalName}/sales/sales-orders/view/${client._id}`
//                           )
//                         }
//                       >
//                         View
//                       </button>

//                       <button
//                         className="bg-green-600 text-white px-3 py-1 rounded"
//                         onClick={() =>
//                           navigate(
//                               `/${portalName}/sales/sales-orders/edit/${client._id}`,
//                             {
//                               state: {
//                                 client,
//                               },
//                             }
//                           )
//                         }
//                       >
//                         Edit
//                       </button>
//                     </div>
//                   ) : (
//                     <button
//                       className="bg-red-500 text-white px-3 py-1 rounded"
//                       onClick={async () => {
//                         await fetchTemplates();

//                         setSelectedHandleBy(
//                           client.handleBy?._id ||
//                           client.userId?._id ||
//                           ""
//                         );

//                         setStartModal({
//                           open: true,
//                           client,
//                         });
//                       }}
//                     >
//                       Start
//                     </button>
//                   )}
//                 </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       <Pagination
//         totalItems={pagination.total}
//         itemsPerPage={itemsPerPage}
//         currentPage={currentPage}
//         onPageChange={setCurrentPage}
//         onItemsPerPageChange={(value) => {
//           setItemsPerPage(value);
//           setCurrentPage(1);
//         }}
//       />
//     </div>
      // {startModal.open && (
      //   <div className="fixed top-[57px] md:top-[65px] inset-0 top bg-black/40 flex items-center justify-center z-[70]">
      //     <div className="bg-white rounded-xl p-6 w-[500px]">
      //       <h2 className="text-xl font-semibold">Start Client Onboarding</h2>

      //       <p className="mt-4 text-gray-600">
      //         Are you sure you want to start onboarding for
      //         <span className="font-semibold ml-1">
      //           {startModal.client?.clientName}
      //         </span>
      //         ?
      //       </p>
      //       <div className="mt-4 space-y-3">
      //         <div>
      //           <label className="block text-sm font-medium text-gray-700">
      //             Product Category
      //           </label>

      //           <div className="mt-1 p-2 bg-gray-50 border rounded-lg text-sm">
      //             {startModal.client?.productCategory?.join(", ") || "Not Available"}
      //           </div>
      //         </div>

      //         <div>
      //           <label className="block text-sm font-medium text-gray-700">
      //             Requirement
      //           </label>

      //           <div className="mt-1 p-2 bg-gray-50 border rounded-lg text-sm">
      //             {startModal.client?.requirement?.join(", ") || "Not Available"}
      //           </div>
      //         </div>
      //       </div>
      //       {(!startModal.client?.productCategory?.length ||
      //         !startModal.client?.requirement?.length) && (
      //         <div className="mt-4 p-3 rounded-lg bg-red-50 border border-red-200 text-red-600 text-sm">
      //           Product Category and Requirement must be available before starting onboarding.
      //         </div>
      //       )}
      //       <div className="mt-4">
      //         <label className="block text-sm font-medium mb-2">
      //           Onboarding Template
      //         </label>

      //         <SelectDropdown
      //           options={templates}
      //           value={selectedTemplate}
      //           onChange={(value) => setSelectedTemplate(value)}
      //           placeholder="Select Template"
      //           valueKey="value"
      //           labelKey="label"
      //           searchable={true}
      //           disabled={templates.length === 1}
      //           zIndex={71}
      //         />
      //       </div>
      //       <div className="mt-4">
      //         <label className="block text-sm font-medium mb-2">
      //           Handle By
      //         </label>

      //         <SelectDropdown
      //           options={users}
      //           value={selectedHandleBy}
      //           onChange={(value) => setSelectedHandleBy(value)}
      //           placeholder="Select User"
      //           valueKey="value"
      //           labelKey="label"
      //           zIndex={71}
      //           searchable={true}
      //         />
      //       </div>
      //       <div className="mt-4">
      //         <label className="block text-sm font-medium mb-2">
      //           Client Onboarding Date
      //         </label>

      //         <CustomDatePicker
      //           value={clientOnboardingDate}
      //           onChange={(date) => setClientOnboardingDate(date)}
      //           placeholder="Select Onboarding Date"
      //           showCapacityInfo={false}
      //         />
      //       </div>
      //       <div className="flex justify-end gap-3 mt-6">
      //         <button
      //           onClick={() =>{
      //             setStartModal({
      //               open: false,
      //               client: null,
      //             })
      //             setSelectedTemplate("");
      //             setSelectedHandleBy("");
      //           }}
      //           className="px-4 py-2 border rounded-lg"
      //         >
      //           Cancel
      //         </button>

      //         <button
      //           disabled={
      //             startingOnboarding ||
      //             !clientOnboardingDate ||
      //             !startModal.client?.productCategory?.length ||
      //             !startModal.client?.requirement?.length
      //           }
      //           onClick={handleStartOnboarding}
      //           className={`px-4 py-2 rounded-lg text-white ${
      //             startingOnboarding ||
      //             !startModal.client?.productCategory?.length ||
      //             !startModal.client?.requirement?.length
      //               ? "bg-gray-400 cursor-not-allowed"
      //               : "bg-red-600"
      //           }`}
      //         >
      //           {startingOnboarding ? "Starting..." : "Confirm"}
      //         </button>
      //       </div>
      //     </div>
      //   </div>
      // )}
//     </>
//   );
// };

// export default OnboardingClients;


import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Filter, Search, Eye, Edit, Play, Edit2 } from "lucide-react";
import { FaArrowLeft } from "react-icons/fa";

import PageLoader from "../helpers/PageLoader";
import ModernTable from "../components/ui/ModernTable"; // ModernTable Path-ஐ உறுதிப்படுத்தவும்
import api from "../common/apiClient";
import SummaryApi from "../common/SummaryApi";
import { formatDateTime } from "../helpers/formatDateTime";
import SelectDropdown from "../customStyles/SelectDropdown";
import CustomDatePicker from "../customStyles/CustomDatePicker";

const clientStatusOptions = [
  { label: "ACTIVE", value: "ACTIVE" },
  { label: "INACTIVE", value: "INACTIVE" },
  { label: "ONETIME", value: "ONETIME" },
];

const clientTypeOptions = [
  { label: "RECURRING", value: "RECURRING" },
  { label: "NON RECURRING", value: "NON_RECURRING" },
];

const OnboardingClients = () => {
  const { portalName } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  // States
  const [loading, setLoading] = useState(true);
  const [clients, setClients] = useState([]);
  const [users, setUsers] = useState([]);
  const [dataCache, setDataCache] = useState({});
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedFilterHandleBy, setSelectedFilterHandleBy] = useState("");
  const [selectedClientStatus, setSelectedClientStatus] = useState("");
  const [selectedClientType, setSelectedClientType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [showFilters, setShowFilters] = useState(true);
  const [templates, setTemplates] = useState([]);
  const [selectedHandleBy, setSelectedHandleBy] = useState("");
  const [clientOnboardingDate, setClientOnboardingDate] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [startingOnboarding, setStartingOnboarding] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const pageParam = parseInt(searchParams.get("page")) || 1;
  const limitParam = searchParams.get("limit") === "All" ? "All" : parseInt(searchParams.get("limit")) || 10;
  const [itemsPerPage, setItemsPerPage] = useState(limitParam);
  const [currentPage, setCurrentPage] = useState(pageParam);
  
  const [appliedFilters, setAppliedFilters] = useState({
    userId: "",
    handleBy: "",
    fromDate: "",
    toDate: "",
    clientStatus: "",
    clientType: "",
  });

  const [pagination, setPagination] = useState({
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 0,
  });

  const [startModal, setStartModal] = useState({
    open: false,
    client: null,
  });

   const updateURL = (newPage, newLimit) => {
    const params = {};
    if (newPage) params.page = newPage;
    if (newLimit) params.limit = newLimit;
    setSearchParams(params);
  };

  const generateCacheKey = useCallback(() => {
    return JSON.stringify({
      page: currentPage,
      limit: itemsPerPage,
      filters: appliedFilters
    });
  }, [currentPage, itemsPerPage, appliedFilters]);

  // Fetch Clients Data
  const fetchClients = useCallback(async (forceRefresh = false) => {
    const cacheKey = generateCacheKey();
  
    // 1. Check: If data exists in cache and forceRefresh is false, use cached data
    if (!forceRefresh && dataCache[cacheKey]) {
      setClients(dataCache[cacheKey].data);
      setPagination(dataCache[cacheKey].pagination);
      setLoading(false);
      return; // API call avoid
    }
  
    try {
      setLoading(true);
      const response = await api({
        ...SummaryApi.getAllWonClients,
        params: { 
          page: currentPage, 
          limit: itemsPerPage,
          ...(appliedFilters.userId && { userId: appliedFilters.userId }),
          ...(appliedFilters.handleBy && { handleBy: appliedFilters.handleBy }),
          ...(appliedFilters.fromDate && { fromDate: appliedFilters.fromDate }),
          ...(appliedFilters.toDate && { toDate: appliedFilters.toDate }),
          ...(appliedFilters.clientStatus && { clientStatus: appliedFilters.clientStatus }),
          ...(appliedFilters.clientType && { clientType: appliedFilters.clientType }),
        },
      });
  
      if (response.data.success) {
        const fetchedData = response.data.data || [];
        const fetchedPagination = response.data.pagination;
  
        setClients(fetchedData);
        setPagination(fetchedPagination);
  
        // 2. Update cache with the newly fetched data
        setDataCache(prev => ({
          ...prev,
          [cacheKey]: { data: fetchedData, pagination: fetchedPagination }
        }));
      }
    } catch (error) {
      toast.error("Failed to fetch");
    } finally {
      setLoading(false);
    }
  }, [currentPage, itemsPerPage, appliedFilters, dataCache, generateCacheKey]);

  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  // Fetch Users
  const fetchUsers = useCallback(async () => {
    try {
      const response = await api.get(SummaryApi.getAllUsers.url);
      if (response.data.success) {
        const activeUsers = (response.data.data || []).filter((u) => u.isActive !== false);
        const formatted = activeUsers.map((u) => ({
          label: `${u.firstName} ${u.lastName} (${u.customRoleId?.roleName || u.role})`,
          value: u._id,
        }));
        setUsers(formatted);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  // Fetch Templates for Modal
  const fetchTemplates = async () => {
    try {
      const response = await api({ ...SummaryApi.getAllOnboardingTemplates });
      if (response.data.success) {
        const templateData = response.data.data || [];
        const formattedTemplates = templateData.map((t) => ({
          label: t.templateName,
          value: t._id,
        }));
        setTemplates(formattedTemplates);
        if (formattedTemplates.length === 1) {
          setSelectedTemplate(formattedTemplates[0].value);
        }
      }
    } catch (error) {
      toast.error("Failed to fetch templates");
    }
  };

  // Start Onboarding Logic
  const handleStartOnboarding = async () => {
    if (startingOnboarding) return;
    try {
      setStartingOnboarding(true);
      const productCategory = startModal.client?.productCategory?.length > 0;
      const requirement = startModal.client?.requirement?.length > 0;

      if (!productCategory) return toast.error("Product Category is required");
      if (!requirement) return toast.error("Requirement is required");
      if (!selectedTemplate) return toast.error("Please select onboarding template");
      if (!selectedHandleBy) return toast.error("Please select handle by");
      if (!clientOnboardingDate) return toast.error("Please select onboarding date");

      await api({
        ...SummaryApi.startClientOnboarding,
        data: {
          clientId: startModal.client._id,
          templateId: selectedTemplate,
          handleBy: selectedHandleBy,
          clientOnboardingDate,
          productCategory: startModal.client.productCategory?.map(item => item?.toLowerCase()?.replace(/\s+/g, "_")) || [],
          requirement: startModal.client.requirement,
        },
      });

      toast.success("Onboarding started successfully");
      setStartModal({ open: false, client: null });
      setClientOnboardingDate("");
      setSelectedTemplate("");
      setSelectedHandleBy("");
      setDataCache({}); // old cache data clear
      fetchClients(true); // 'true' to force refresh and fetch new data from API
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to start onboarding");
    } finally {
      setStartingOnboarding(false);
    }
  };

  // Filters Logic
  const handleApplyFilters = () => {
    setAppliedFilters({
      userId: selectedUser,
      handleBy: selectedFilterHandleBy,
      clientStatus: selectedClientStatus,
      clientType: selectedClientType,
      fromDate,
      toDate,
    });
    setCurrentPage(1);
    updateURL(1, itemsPerPage);
  };

  const handleClearFilters = () => {
    setSelectedUser("");
    setFromDate("");
    setToDate("");
    setSelectedFilterHandleBy("");
    setSelectedClientStatus("");
    setSelectedClientType("");
    setAppliedFilters({
      userId: "",
      fromDate: "",
      handleBy: "",
      toDate: "",
      clientStatus: "",
      clientType: "",
    });
    setCurrentPage(1);
  };

  const hasChanges = useMemo(() => (
    selectedUser !== appliedFilters.userId ||
    selectedFilterHandleBy !== appliedFilters.handleBy ||
    fromDate !== appliedFilters.fromDate ||
    toDate !== appliedFilters.toDate || 
    selectedClientStatus !== appliedFilters.clientStatus ||
    selectedClientType !== appliedFilters.clientType
  ), [selectedUser, selectedFilterHandleBy, fromDate, toDate, selectedClientStatus, selectedClientType, appliedFilters]);

  // Search Filter
  const filteredClients = useMemo(() => {
    const search = searchTerm.toLowerCase();
    return clients.filter((client) => (
      client.clientName?.toLowerCase().includes(search) ||
      client.contactName?.toLowerCase().includes(search) ||
      client.clientId?.toLowerCase().includes(search) ||
      client.contactPhone?.toLowerCase().includes(search)
    ));
  }, [clients, searchTerm]);

  // ModernTable Column Definitions
  const columns = [
    {
      label: "S.No",
      key: "sno",
      headerAlign: "center",
      render: (row) => {
        const index = filteredClients.findIndex(c => c._id === row._id);
        // if itemsPerPage is "All", offset 0 will be returned
        const offset = (itemsPerPage === "All" || !itemsPerPage) ? 0 : (currentPage - 1) * itemsPerPage;
        return offset + index + 1;
      }
    },
    {
      label: "Client/Id",
      key: "client",
      render: (row) => (
        <div className="min-w-[140px]">
          <p className="font-medium text-gray-800">{row.clientName}</p>
          <p className="text-xs text-gray-500">{row.clientId}</p>
        </div>
      )
    },
    {
      label: "Client Contact",
      key: "contact",
      render: (row) => (
        <div className="min-w-[140px]">
          <p className="font-medium text-gray-800">{row.contactPhone}</p>
          <p className="text-xs text-gray-500">{row.contactName}</p>
        </div>
      )
    },
    {
      label: "Handled By",
      key: "handleBy",
      render: (row) => (
        <div className="min-w-[140px]">
          <p className="font-medium text-gray-800">{row.handleBy?.firstName} {row.handleBy?.lastName}</p>
          <p className="text-xs text-gray-500">{row.handleBy?.userId || "N/A"}</p>
        </div>
      )
    },
    {
      label: "Sales By",
      key: "salesBy",
      render: (row) => (
        <div className="min-w-[140px]">
          <p className="font-medium text-gray-800">{row.userId?.firstName} {row.userId?.lastName}</p>
          <p className="text-xs text-gray-500">{row.userId?.userId || "N/A"}</p>
        </div>
      )
    },
    {
      label: "Product Category",
      key: "productCategory",
      render: (row) => (
        <span className="px-2 py-1 bg-red-50 text-red-600 rounded-lg text-xs font-medium border border-red-100">
          {row.productCategory?.join(", ") || "N/A"}
        </span>
      )
    },
    {
      label: "Overall Value(IV)",
      key: "estimatedValue",
      headerAlign: "center",
      render: (row) => `₹ ${row.estimatedValue || 0}`
    },
    {
      label: "Recurring Value",
      key: "recurringValue",
      headerAlign: "center",
      render: (row) => row.clientType === "RECURRING" ? `₹ ${row.recurringValue || 0}` : "₹ 0"
    },
    {
      label: "Won Date",
      key: "wonDate",
      render: (row) => formatDateTime(row.stageChangedAt, false)
    },
    {
      label: "Phase Status",
      key: "onboardingStatus",
      headerAlign: "center",
      render: (row) => {
        let color = "bg-red-100 text-red-700";
        let label = "PENDING";
        if(row.onboardingStatus === "COMPLETED") { color = "bg-green-100 text-green-700"; label = "COMPLETED"; }
        else if(row.onboardingStatus === "IN_PROGRESS") { color = "bg-yellow-100 text-yellow-700"; label = "IN PROGRESS"; }
        return <span className={`px-2 py-1 rounded-full text-[11px] font-medium ${color}`}>{label}</span>;
      }
    },
    {
      label: "Client Status",
      key: "clientStatus",
      headerAlign: "center",
      render: (row) => {
        const colors = { ACTIVE: "bg-green-100 text-green-700", INACTIVE: "bg-red-100 text-red-700", ONETIME: "bg-blue-100 text-blue-700" };
        return <span className={`px-2 py-1 rounded-full text-[11px] font-medium ${colors[row.clientStatus] || "bg-gray-100 text-gray-600"}`}>
          {row.clientStatus || "NOT SET"}
        </span>;
      }
    },
    {
      label: "Client Type(PS)",
      key: "clientType",
      headerAlign: "center",
      render: (row) => {
        const colors = { RECURRING: "bg-purple-100 text-purple-700", NON_RECURRING: "bg-orange-100 text-orange-700" };
        return <span className={`px-2 py-1 rounded-full text-[11px] font-medium ${colors[row.clientType] || "bg-gray-100 text-gray-600"}`}>
          {row.clientType?.replace("_", " ") || "NOT SET"}
        </span>;
      }
    }
  ];

  // ModernTable Actions with Conditions
  const actions = [
    {
      label: "View",
      icon: <Eye size={16} />,
      onClick: (row) => navigate(`/${portalName}/sales/sales-orders/view/${row._id}`),
      show: (row) => row.onboardingStarted // if Onboarding Start
    },
    {
      label: "Edit",
      icon: <Edit size={16} />,
      onClick: (row) => navigate(`/${portalName}/sales/sales-orders/edit/${row._id}`, { state: { client: row } }),
      show: (row) => row.onboardingStarted // if Onboarding Start
    },
    {
      label: "Start",
      icon: <Play size={16} />,
      onClick: async (row) => {
        await fetchTemplates();
        setSelectedHandleBy(row.handleBy?._id || row.userId?._id || "");
        setStartModal({ open: true, client: row });
      },
      show: (row) => !row.onboardingStarted // if Onboarding Start
    },
    {
      label: "Lead Edit",
      icon: <Edit2 size={16} />,
      onClick: (row) => navigate(`/${portalName}/sales/leads/edit/${row._id}`),
      show: () => true
    }
  ];

  return (
    <>
      <div className="w-full p-4">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
          <div className="flex items-center">
            <button onClick={() => navigate(-1)} className="mr-2 hover:bg-gray-300 rounded-full p-1">
              <FaArrowLeft />
            </button>
            <h1 className="text-2xl font-bold">Onboarded Clients</h1>
          </div>

          <div className="flex items-center gap-2">
            <div className="relative w-full md:w-80">
              <input
                type="text"
                placeholder="Search client..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 outline-none"
              />
              <Search className="absolute left-3 top-3 text-gray-400" size={18} />
            </div>

            <button
              onClick={() => setShowFilters(!showFilters)}
              className={`p-2 rounded-lg transition ${showFilters ? "bg-red-100 text-red-600" : "bg-gray-100 text-gray-600"}`}
            >
              <Filter size={24} />
            </button>
          </div>
        </div>

        {/* Filters Section */}
        {showFilters && (
          <div className="bg-white rounded-md p-4 mb-4 shadow-sm border border-gray-100">
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-6 gap-3">
              <div>
                <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Sales By</label>
                <SelectDropdown options={users} value={selectedUser} onChange={setSelectedUser} placeholder="All Users" searchable labelKey="label" valueKey="value" />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Handle By</label>
                <SelectDropdown options={users} value={selectedFilterHandleBy} onChange={setSelectedFilterHandleBy} placeholder="All Handlers" searchable labelKey="label" valueKey="value" />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Client Status</label>
                <SelectDropdown options={clientStatusOptions} value={selectedClientStatus} onChange={setSelectedClientStatus} placeholder="All Status" labelKey="label" valueKey="value" />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Client Type</label>
                <SelectDropdown options={clientTypeOptions} value={selectedClientType} onChange={setSelectedClientType} placeholder="All Types" labelKey="label" valueKey="value" />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">From Date</label>
                <CustomDatePicker value={fromDate} onChange={(date) => { setFromDate(date); if (!toDate && date) setToDate(date); }} placeholder="Select Date" />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">To Date</label>
                <CustomDatePicker value={toDate} onChange={(date) => { setToDate(date); if (!fromDate && date) setFromDate(date); }} placeholder="Select Date" />
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-4">
                <button
                  disabled={!hasChanges}
                  onClick={handleApplyFilters}
                  className={`px-6 py-2 rounded-lg text-sm font-semibold text-white transition ${hasChanges ? "bg-red-500 hover:bg-red-600 shadow-md" : "bg-gray-300 cursor-not-allowed"}`}
                >
                  Apply Filters
                </button>
                <button onClick={handleClearFilters} className="px-6 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg text-sm font-semibold transition">
                  Clear
                </button>
              </div>
          </div>
        )}

        {/* Modern Table Integration */}
        {loading ? (
          <PageLoader />
        ) : (
          <ModernTable
            columns={columns}
            data={filteredClients}
            actions={actions}
            actionType="dropdown" // 3 dots dropdown
            selectable={false}
            // pagination={{
            //   totalItems: pagination.total,
            //   itemsPerPage: itemsPerPage,
            //   currentPage: currentPage,
            //   onPageChange: (p) => setCurrentPage(p),
            //   onItemsPerPageChange: (v) => { setItemsPerPage(v); setCurrentPage(1); }
            // }}
            
            pagination={{
              totalItems: pagination.total,
              itemsPerPage: itemsPerPage,
              currentPage: currentPage,
              onPageChange: (p) => {
                setCurrentPage(p);
                updateURL(p, itemsPerPage); // it will update the URL
              },
              onItemsPerPageChange: (v) => {
                setItemsPerPage(v);
                setCurrentPage(1);
                updateURL(1, v); // it will update the URL
              }
            }}
          />
        )}
      </div>

      {/* Start Onboarding Modal */}
      {startModal.open && (
        <div className="fixed top-[57px] md:top-[65px] inset-0 top bg-black/40 flex items-center justify-center z-[70]">
          <div className="bg-white rounded-xl p-6 w-[500px]">
            <h2 className="text-xl font-semibold">Start Client Onboarding</h2>

            <p className="mt-4 text-gray-600">
              Are you sure you want to start onboarding for
              <span className="font-semibold ml-1">
                {startModal.client?.clientName}
              </span>
              ?
            </p>
            <div className="mt-4 space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Product Category
                </label>

                <div className="mt-1 p-2 bg-gray-50 border rounded-lg text-sm">
                  {startModal.client?.productCategory?.join(", ") || "Not Available"}
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Requirement
                </label>

                <div className="mt-1 p-2 bg-gray-50 border rounded-lg text-sm">
                  {startModal.client?.requirement?.join(", ") || "Not Available"}
                </div>
              </div>
            </div>
            {(!startModal.client?.productCategory?.length ||
              !startModal.client?.requirement?.length) && (
              <div className="mt-4 p-3 rounded-lg bg-red-50 border border-red-200 text-red-600 text-sm">
                Product Category and Requirement must be available before starting onboarding.
              </div>
            )}
            <div className="mt-4">
              <label className="block text-sm font-medium mb-2">
                Onboarding Template
              </label>

              <SelectDropdown
                options={templates}
                value={selectedTemplate}
                onChange={(value) => setSelectedTemplate(value)}
                placeholder="Select Template"
                valueKey="value"
                labelKey="label"
                searchable={true}
                disabled={templates.length === 1}
                zIndex={71}
              />
            </div>
            <div className="mt-4">
              <label className="block text-sm font-medium mb-2">
                Handle By
              </label>

              <SelectDropdown
                options={users}
                value={selectedHandleBy}
                onChange={(value) => setSelectedHandleBy(value)}
                placeholder="Select User"
                valueKey="value"
                labelKey="label"
                zIndex={71}
                searchable={true}
              />
            </div>
            <div className="mt-4">
              <label className="block text-sm font-medium mb-2">
                Client Onboarding Date
              </label>

              <CustomDatePicker
                value={clientOnboardingDate}
                onChange={(date) => setClientOnboardingDate(date)}
                placeholder="Select Onboarding Date"
                showCapacityInfo={false}
              />
            </div>
            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() =>{
                  setStartModal({
                    open: false,
                    client: null,
                  })
                  setSelectedTemplate("");
                  setSelectedHandleBy("");
                }}
                className="px-4 py-2 border rounded-lg"
              >
                Cancel
              </button>

              <button
                disabled={
                  startingOnboarding ||
                  !clientOnboardingDate ||
                  !startModal.client?.productCategory?.length ||
                  !startModal.client?.requirement?.length
                }
                onClick={handleStartOnboarding}
                className={`px-4 py-2 rounded-lg text-white ${
                  startingOnboarding ||
                  !startModal.client?.productCategory?.length ||
                  !startModal.client?.requirement?.length
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-red-600"
                }`}
              >
                {startingOnboarding ? "Starting..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OnboardingClients;